export const getAppVersion = ({ app: { version } }) => version;
